import { BaseAPI } from "../core/BaseAPI";
import { FinancialStatementRepository } from "../repositories/FinancialStatementRepository";
import { IAuthService } from "./AuthService";
import { HttpConfig } from "../helpers/http.config";
import { APIResponse } from "../models/APIResponse";
import {
  FinancialStatementResponseDto,
  FinancialStatementView,
} from "../dto/FinancialStatement";
import { Result } from "../core/Result";
import { left, right } from "../core/Either";
import { toApiError } from "../helpers/api.error";
import { FinancialUtil } from "../mappers/FinancialUtil";

export class FinancialStatementHttp
  extends BaseAPI
  implements FinancialStatementRepository
{
  async load(): Promise<APIResponse<FinancialStatementView | null>> {
    try {
      const res = await this.get<FinancialStatementResponseDto>(
        "/standard-financial-statement",
      );
      return right(
        Result.ok<FinancialStatementView>(FinancialUtil.toViewModel(res.data)),
      );
    } catch (e) {
      return left(toApiError(e));
    }
  }

  async save(dto: Omit<FinancialStatementView, "totals">): Promise<APIResponse<void>> {
    try {
      const payload = FinancialUtil.sendViewModel(dto);
      await this.post("/standard-financial-statement", payload);
      return right(Result.ok<void>());
    } catch (e) {
      return left(toApiError(e));
    }
  }
}

// Optional factory
export const financialStatementHttp = (auth: IAuthService, cfg: HttpConfig) =>
  new FinancialStatementHttp(auth, cfg);
